import { render, staticRenderFns } from "./MainSystem.vue?vue&type=template&id=46799c20&scoped=true&"
import script from "./MainSystem.vue?vue&type=script&lang=js&"
export * from "./MainSystem.vue?vue&type=script&lang=js&"
import style0 from "./MainSystem.vue?vue&type=style&index=0&id=46799c20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46799c20",
  null
  
)

export default component.exports